export default __webpack_public_path__ + "static/media/meraki-landing-page.e6f9a597.svg";